// extracted by mini-css-extract-plugin
export default {"emptyTrophyCase":"EmptyTrophyCase--emptyTrophyCase--a8eNe"};